import React, { useEffect, useRef } from 'react';
import { motion, useAnimationFrame, useTime, useTransform } from "motion/react";
import { PageTransitions } from '../../../../utils/transitions';

const root = '/pips/';

const planetImages = [
    'd20.png',
    'd12.png',
    'd10.png',
    'd8.png',
    'd6.png',
]

interface PlanetProps {
    src: string,
    offset: number,
    w: React.RefObject<number>,
    h: React.RefObject<number>,
}

const orbitDuration = 6500;

const Planet: React.FC<PlanetProps> = ({ src, offset, w, h }) => {
    const t = useTime();
    const theta = useTransform(() => (t.get() + offset) * (2*Math.PI) / orbitDuration);
    const x = useTransform(() => .3 * w.current * Math.cos(theta.get()));
    const y = useTransform(() => .3 * h.current * Math.sin(theta.get()));
    const rotateZ = useTransform(theta, [0, 2*Math.PI], ['0deg', '360deg'], { clamp: false })

    return (
        <motion.img
            layout
            src={`${root}${src}`}
            style={{
                translateX: '-50%', translateY:'-50%',
                scale: .4,
                x, y, 
                rotateZ
             }}
        />
    )
}

const PipsPageFrame: React.FC<{ children: any, className?: string }> = ({ children, className }) => {
    const mainRef = useRef(null);

    const w = useRef(0);
    const h = useRef(0);

    useEffect(() => {
        if (!mainRef.current) return;

        const observer = new ResizeObserver((entries) => {
            for (const e of entries) {
                w.current = e.contentRect.width;
                h.current = e.contentRect.height;
            }
        });

        observer.observe(mainRef.current)
        return () => observer.disconnect()
    }, [])

    useAnimationFrame(() => {

    })

    return (
        <motion.div
            ref={mainRef}
            variants={PageTransitions}
            initial='initial'
            animate='animate'
            exit='exit'
            className={'w-full flex flex-col grow py-6 justify-center items-center relative overflow-hidden ' + className || ''}
        >
            {children}
            <div className={'absolute top-0 left-0 size-full -z-10 pointer-events-none'}>
                <img
                    src={'/pips/cris-menles-bg.jpg'}
                    className='object-cover size-full'
                />
            </div>

            <div className='absolute bottom-0 left-0 -z-10'>
                {planetImages.map((v, i) => <Planet key={i} src={v} offset={i * orbitDuration / planetImages.length} w={w} h={h} />)}
            </div>
        </motion.div>
    )
}

export default PipsPageFrame;